import {POST} from '../modules/fetch.ts';
import {queryElems, toggleElem} from '../utils/dom.ts';
import {IssueSidebarComboList} from './repo-issue-sidebar-combolist.ts';

function initBranchSelector() {
  // TODO: RemoveIssueRef: see "repo/issue/branch_selector_field.tmpl"
  const elSelectBranch = document.querySelector('.ui.dropdown.select-branch.branch-selector-dropdown');
  if (!elSelectBranch) return;

  const urlUpdateIssueRef = elSelectBranch.getAttribute('data-url-update-issueref');
  const elBranchMenu = elSelectBranch.querySelector('.reference-list-menu');
  queryElems(elBranchMenu, '.item:not(.no-select)', (el) => el.addEventListener('click', async function (e) {
    e.preventDefault();
    const selectedValue = this.getAttribute('data-id'); // eg: "refs/heads/my-branch"
    const selectedText = this.getAttribute('data-name'); // eg: "my-branch"
    if (urlUpdateIssueRef) {
      // for existing issue, send request to update issue ref, and reload page
      try {
        await POST(urlUpdateIssueRef, {data: new URLSearchParams({ref: selectedValue})});
        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    } else {
      // for new issue, only update UI&form, do not send request/reload
      const selectedHiddenSelector = this.getAttribute('data-id-selector');
      document.querySelector<HTMLInputElement>(selectedHiddenSelector).value = selectedValue;
      elSelectBranch.querySelector('.text-branch-name').textContent = selectedText;
    }
  }));
}

function initRepoIssueDue() {
  const sidebar = document.querySelector('.issue-content-right');
  if (!sidebar) return;

  let isUpdating = false;

  // Use event delegation on stable parent
  sidebar.addEventListener('change', async (e: Event) => {
    const target = e.target as HTMLInputElement;
    if (!target.matches('.issue-due-form input[name="deadline"]')) return;
    if (!target.value) return;
    if (isUpdating) return;

    const form = target.closest('form');
    if (!form) return;

    isUpdating = true;
    try {
      const response = await POST(form.getAttribute('action'), {data: new FormData(form)});
      if (!response.ok) throw new Error('Failed to update due date');

      const html = await response.text();
      const container = sidebar.querySelector('#issue-due-date-section');
      if (container) container.innerHTML = html;
    } catch (error) {
      console.error(error);
    } finally {
      isUpdating = false;
    }
  });

  sidebar.addEventListener('click', async (e: Event) => {
    const target = e.target as HTMLElement;

    // Handle edit button
    if (target.closest('.issue-due-edit')) {
      e.preventDefault();
      const form = sidebar.querySelector('.issue-due-form');
      if (form) toggleElem(form);
      return;
    }

    // Handle remove button
    if (target.closest('.issue-due-remove')) {
      e.preventDefault();
      if (isUpdating) return;

      const form = sidebar.querySelector<HTMLFormElement>('.issue-due-form');
      if (!form) return;

      const deadline = form.querySelector<HTMLInputElement>('input[name="deadline"]');
      if (!deadline) return;

      deadline.value = '';
      isUpdating = true;
      try {
        const response = await POST(form.getAttribute('action'), {data: new FormData(form)});
        if (!response.ok) throw new Error('Failed to remove due date');

        const html = await response.text();
        const container = sidebar.querySelector('#issue-due-date-section');
        if (container) container.innerHTML = html;
      } catch (error) {
        console.error(error);
      } finally {
        isUpdating = false;
      }
    }
  });
}

export function initRepoIssueSidebar() {
  initBranchSelector();
  initRepoIssueDue();

  // init the combo list: a dropdown for selecting items, and a list for showing selected items and related actions
  queryElems<HTMLElement>(document, '.issue-sidebar-combo', (el) => new IssueSidebarComboList(el).init());
}
